import { render } from "./ProjectAnalysisTextMain.vue?vue&type=template&id=0366a93a&scoped=true"
import script from "./ProjectAnalysisTextMain.vue?vue&type=script&lang=js"
export * from "./ProjectAnalysisTextMain.vue?vue&type=script&lang=js"

import "./ProjectAnalysisTextMain.vue?vue&type=style&index=0&id=0366a93a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0366a93a"]])

export default __exports__